// extracted by mini-css-extract-plugin
export var icon = "_7d-1";
export var subtext = "_7d-0";